import { useToast } from "@/composables/useToast";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { TokenType } from "@/config/token-types";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import { useOrchestratorContract } from "@/web3/contracts";

export const claimMeth = async (items) => {
  const payload = {
    bullTokens: items
      .filter((item) => item.type === TokenType.GENESIS)
      .map((item) => item.id),
    godTokens: items
      .filter((item) => item.type === TokenType.GOD)
      .map((item) => item.id),
    teenTokens: items
      .filter((item) => item.type === TokenType.TEEN && item.isResurrected)
      .map((item) => item.id),
    methToClaim: items.reduce((sum, item) => sum + item.claimableMeth, 0),
  };

  const contract = useOrchestratorContract(true);

  const { bullTokens, godTokens, teenTokens, methToClaim } = payload;
  const claimResponse = await useToastTransaction(
    contract.methods.claimMeth(bullTokens, godTokens, teenTokens),
    {
      text: "Claiming Meth",
    }
  );

  useToast().success({
    title: `Congrats! Your wallet now has +${methToClaim} METH`,
  });
  useWeb3Store().update();
  useWalletCollectionStore().fetchCollection(true);
  return claimResponse;
};
